
import React from 'react';
import { render } from 'react-dom';
// importing this init's it
import configureStore from './configureStore';
import App from './containers/App';

render(<App />, document.getElementById('hifi-app'));

